import * as nativeApi from '../../nativeApi/index';
import gcoord from 'gcoord';

// App 位置处理类
class AppLocation {
    constructor() {}

    getLocation() {
        console.log('get app location');

        return nativeApi.getLocation().then(res => {
            console.log(`get app location`, res);
            if (res.state === 0) {
                let transformResult = res.data || {};
                if (!transformResult.lat || !transformResult.lng) {
                    window.monitor &&
                        window.monitor.report({
                            level: 'info',
                            url: window.location.href,
                            msg: 'nativeApi.getLocation error' + JSON.stringify(transformResult),
                        });
                }
                if (window.ZZCFL.Utils.UA.os.name == 'android' && !window.zzcjsbridge.base_requestLocation_new) {
                    // 需要转换两次(⊙﹏⊙), ref: shop/src/topic/views/kfc/utils/location.js line:199
                    transformResult = gcoord.transform(
                        [transformResult.lng, transformResult.lat],
                        gcoord.GCJ02,
                        gcoord.WGS84
                    );
                    transformResult.lat = transformResult[1];
                    transformResult.lng = transformResult[0];
                    transformResult = gcoord.transform(
                        [transformResult.lng, transformResult.lat],
                        gcoord.GCJ02,
                        gcoord.WGS84
                    );
                    transformResult.lat = transformResult[1];
                    transformResult.lng = transformResult[0];
                }

                // 原生返回的是火星坐标，默认转换成WGS84坐标
                // var transformResult = gcoord.transform([result.lng, result.lat], gcoord.GCJ02, gcoord.WGS84);
                return {
                    latitude: transformResult.lat,
                    longitude: transformResult.lng,
                };
            } else if (res.state === 1) {
                return Promise.reject('没权限');
            } else {
                return Promise.reject('定位失败');
            }
        });
    }

    //
    //
    // aMapGps:{startLng:""（可选）, startLat:""（可选）, endLng:"", endLat:"", },
    //
    // baiduGps:{xxx},
    // success: function (response) {
    //     console.log(response);
    // }

    openLocation(options) {
        let target = options;
        console.log('open app location');
        let params = {
            startPlace: '我的位置',
            endPlace: target.name,

            //默认GPS,地球坐标系，国际通用坐标系 WGS84坐标系
            startLng: '',
            startLat: '',
            endLng: target.longitude,
            endLat: target.latitude,

            //火星坐标系，WGS84坐标系加密后的坐标系；Google国内地图、高德、QQ地图 使用
            aMapGps: {
                startLng: '',
                startLat: '',
                endLng: target.gcjLongitude,
                endLat: target.gcjLatitude,
            },

            //百度经纬度，BD09坐标系
            baiduGps: {
                startLng: '',
                startLat: '',
                endLng: target.bdLongitude,
                endLat: target.bdLatitude,
            },
        };
        return nativeApi.openLocation(params);
    }
}

export default AppLocation;
